import Modal from 'react-bootstrap/Modal';

const ModalDescargarArchivo = (props) => {
    const { onHide, datosModal, ...rest } = props;
    const { estadoSolicitud, mensaje } = datosModal;

    return (
        <Modal
            {...props}
            size="md"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            keyboard="false"
        >
            <Modal.Body>
                <div className='info my-4'>
                {estadoSolicitud ? ( 
                    <>
                    <h6 className='info__title'>Envio Solicitud</h6>
                    <p className='info__text'>{mensaje}</p>
                    </>
                ) : (
                    <>
                    <h6 className='info__title'>Error en la Solicitud</h6>
                    <p className='info__text'>{mensaje}</p>
                    </>
                )}  
                </div>
                <div className="text-center">
                {estadoSolicitud ? (
                <button className="link text-pewter-blue border-5 border border-success rounded-5 bg-success fs-4 text-white" onClick={onHide}><i className="ico-check"></i></button>
                ) : (
                <button className="link text-pewter-blue border-5 border border-danger rounded-5 bg-danger fs-4 text-white" onClick={onHide}><i className="ico-close"></i></button>
                )}
                </div>
            </Modal.Body>
        </Modal>
    );
}

export default ModalDescargarArchivo;
